(function () {
  if (customElements.get('homepage-product-collection-slider')) return;

  class HomepageProductCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.handleViewportChange = this.updateSlider.bind(this);
      this.handleWindowResize = this.updateSliderSpacing.bind(this);
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
      window.addEventListener('resize', this.handleWindowResize);
      this.updateSlider();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
      window.removeEventListener('resize', this.handleWindowResize);
      this.destroySlider();
    }

    updateSlider() {
      if (this.mobileQuery.matches) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (this.slider || typeof window.Swiper !== 'function') return;

      this.slider = new window.Swiper(this, {
        slidesPerView: 2.1,
        spaceBetween: this.getSliderGap(),
        watchOverflow: true,
        observer: true,
        observeParents: true
      });
    }

    getSliderGap() {
      return window.innerWidth * 8 / 390;
    }

    updateSliderSpacing() {
      if (!this.slider) return;
      this.slider.params.spaceBetween = this.getSliderGap();
      this.slider.update();
    }

    destroySlider() {
      if (!this.slider) return;
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  customElements.define('homepage-product-collection-slider', HomepageProductCollectionSlider);
})();
